export default "__VITE_ASSET__J6BuE2Np__"